import { render, staticRenderFns } from "./navMenu.vue?vue&type=template&id=5cadb40a&scoped=true"
import script from "./navMenu.vue?vue&type=script&lang=js"
export * from "./navMenu.vue?vue&type=script&lang=js"
import style0 from "./navMenu.vue?vue&type=style&index=0&id=5cadb40a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cadb40a",
  null
  
)

export default component.exports